module.exports = __webpack_public_path__ + "static/img/aboutUs03.5dbc3c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs03.jpg
// module id = 1355
// module chunks = 1